import { render, staticRenderFns } from "./HomePurchase.vue?vue&type=template&id=21c0503b&scoped=true&"
import script from "./HomePurchase.vue?vue&type=script&lang=js&"
export * from "./HomePurchase.vue?vue&type=script&lang=js&"
import style0 from "./HomePurchase.vue?vue&type=style&index=0&id=21c0503b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c0503b",
  null
  
)

export default component.exports